import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Loading in fonts from local folder
import "./fonts/almondbutter.ttf";
import './fonts/AmazinglyBeautifulRegular.ttf';
import './fonts/aurora.ttf';
import "./fonts/Autery.ttf";
import "./fonts/Babypoint.ttf";
import "./fonts/Bakedfresh.ttf";
import "./fonts/blossom.ttf";
import "./fonts/BohoFlowers.otf";
import "./fonts/Brooklyn.ttf"
import "./fonts/centuryGothic.ttf";
import "./fonts/Chakra.ttf";
import "./fonts/classico.ttf";
import "./fonts/Clocks.ttf";
import "./fonts/Cookie.ttf";
import "./fonts/Doodle.ttf";
import "./fonts/Eduarda.ttf";
import "./fonts/Farmhouse.ttf";
import "./fonts/Ghisella.ttf";
import "./fonts/Hancock.ttf";
import "./fonts/Harpsichord.ttf";
import "./fonts/Langrish.ttf";
import "./fonts/Layla.ttf";
import "./fonts/Lively.ttf";
import "./fonts/pinksoda.otf"
import "./fonts/September.ttf"
import "./fonts/Sweetheart.ttf";
import "./fonts/sweetpea.otf"
import "./fonts/Tatertot.ttf";
import "./fonts/xmasMint.ttf"
import "./fonts/Violetta.ttf";
import "./fonts/Wonderful.otf";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
